import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import KontentAssetsImage from "./kontentAssetsImage";
import SimpleRichText from "./text/simpleRichText";
import LogoTile from "../components/logoTile/logoTile";

const KontentItemLogoTile = ({ data: { elements } }) => {
  if (!elements) {
    return null;
  }

  return (
    <LogoTile
      logo={(
        <KontentAssetsImage
          data={{
            ...elements.logo.value[0],
            description: elements.title.value,
          }}
          aspectRatio={1}
        />
      )}
      name={elements.title.value}
      description={elements.description.value !== "<p><br></p>"
        ? <SimpleRichText data={{ value: elements.description.value }} />
        : null}
      url={elements.web_url.value}
    />
  );
};

export const query = graphql`
  fragment KontentItemLogoTile on kontent_item_logo_tile {
    id
    system {
      codename
    }
    elements {
      title {
        value
      }
      description {
        value
      }
      logo {
        value {
          description
          height
          name
          size
          type
          url
          width
        }
      }
      web_url {
        value
      }
    }
  } 
`;

KontentItemLogoTile.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemLogoTile;
